import React from "react";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box } from "@mui/material";

import { apply } from "@/utils/functions";

import { MultipleChoiceBlock, MultipleChoiceResponse } from "../types";

interface Props {
  question: MultipleChoiceBlock;
  response: MultipleChoiceResponse;
}

const MultipleChoice: React.FC<Props> = ({ question, response }) => {
  const renderChecked = (choiceId: string) => {
    const checked = response.data.find((d) => d.id === choiceId);

    if (question.data.multiple) {
      return checked ? (
        <CheckBoxIcon htmlColor="#91B602" />
      ) : (
        <CheckBoxOutlineBlankIcon htmlColor="#B8BEC9" />
      );
    } else {
      return checked ? (
        <RadioButtonCheckedIcon htmlColor="#91B602" />
      ) : (
        <RadioButtonUncheckedIcon htmlColor="#B8BEC9" />
      );
    }
  };

  return (
    <Box>
      <Box fontSize={14} fontWeight="600" color="#112340">
        {question.data.title}
      </Box>
      <Box display="flex" flexDirection="column" gap="8px" mt="8px">
        {question.data.choices.map((choice) => (
          <Box key={choice.id} display="flex" alignItems="center" gap="10px">
            {renderChecked(choice.id)}
            <Box fontSize="14px" fontWeight="600" color="#7D8797">
              {choice.label}
            </Box>
          </Box>
        ))}
        {question.data.other && (
          <Box display="flex" alignItems="center" gap="10px">
            {renderChecked("other")}
            <Box fontSize="14px" fontWeight="600" color="#7D8797">
              {apply(
                response.data.find((d) => d.id === "other"),
                (other) => `Other: ${other.text}`
              ) ?? "Other"}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MultipleChoice;
